import React from 'react';
import upperFirst from 'lodash/upperFirst';

import useThrottleInstallGameClick from 'hooks/useThrottleInstallGameClick';
import useThrottleClick from 'hooks/useThrottleClick';
import Game from 'components/game';
import Video from 'components/video';
import ButtonLink from 'components/button-link';
import { TGame, Genre, Route } from 'types';
import './styles.scss';

interface IGenreGames {
  genre: Genre;
  games: TGame[];
  noMoreLink?: boolean;
}

const GenreGames: React.FC<IGenreGames> = ({ games, genre, noMoreLink = false}) => {
  const mainGame = games.find((game: TGame) => !!game.videoShort) as TGame;

  const onMoreLinkClick = useThrottleClick(Route.genres, genre);
  const onMainGameClick = useThrottleInstallGameClick(mainGame);

  return (
    <div className="genre-games-container">
      {mainGame && (
        <div className="relative">
          {mainGame.videoShort && (
            <Video
              muted
              autoRepeat
              autoPlayInView
              hideVolumeControls
              withControls={false}
              url={mainGame.videoShort}
              poster={mainGame.videoPoster}
              handleClick={onMainGameClick}
            />
          )}
          <Game compact aboveParent game={mainGame} />
        </div>
      )}
      <div className='genre-games'>
        {games.filter((game: TGame) => game.id !== mainGame?.id).map((game: TGame) => (
          <Game key={game.id} game={game} />
        ))}
      </div>
      {!noMoreLink && (
        <div>
          <ButtonLink onClick={onMoreLinkClick}>{`More ${upperFirst(genre)} →`}</ButtonLink>
        </div>
      )}
    </div>
  );
};

export default GenreGames;
